export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'right',
    width: 110,
    slots: { default: 'opt' },
  },
  {
    field: 'colorName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('table_head_colorName') || '颜色名称',
    showHeaderOverflow: true,
  },
  {
    field: 'colorNameEn',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('table_head_colorNameEn') || '颜色名称',
    showHeaderOverflow: true,
  },
  {
    field: 'mainColor',
    headerAlign: 'center',
    align: 'center',
    minWidth: 80,
    title: that.$l('table_head_mainColor') || '色系',
    showHeaderOverflow: true,
  },
  {
    field: 'colorCard',
    headerAlign: 'center',
    align: 'center',
    minWidth: 80,
    title: that.$l('table_head_colorCard') || '颜色值',
    showHeaderOverflow: true,
  },
  {
    field: 'isCustomer',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_isCustomer') || '是否客户颜色',
    showHeaderOverflow: true,
    slots: { default: 'isCustomer' },
  },
  {
    field: 'brandName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    title: that.$l('table_label_brand_name') || '品牌名称',
    showHeaderOverflow: true,
  },
  {
    field: 'colorBlock',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_color_block') || '色块',
    showHeaderOverflow: true,
    slots: { default: 'colorCard' },
  },
  {
    field: 'colorStatusName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    title: that.$l('INDEX.Status') || '有效状态',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    field: 'remark',
    headerAlign: 'center',
    align: 'center',
    minWidth: 220,
    title: that.$l('table_label_remarks') || '备注',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 160,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
  },
  {
    field: 'createDate',
    align: 'center',
    minWidth: 170,
    title: that.$l('INDEX.create_date') || '创建时间',
    showHeaderOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    minWidth: 160,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
  },
  {
    field: 'modifyDate',
    align: 'center',
    minWidth: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_submitByName') || '提交人',
    field: 'submitByName',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_submitTime') || '提交时间',
    field: 'submitTime',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_approvalByName') || '审批人',
    field: 'approvalByName',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_approvedTime') || '审批时间',
    field: 'approvedTime',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
]
